var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 13.5v-.6c0-5.2-3-9.4-7-9.4s-6.8 4.2-6.8 9.4v.6c-1.5.3-2.6 1.3-2.6 2.6v9.7c0 1.5 1.5 2.8 3.2 2.8h12.6c1.7 0 3.2-1.2 3.2-2.8v-9.7c0-1.3-1-2.5-2.6-2.6M12 12.9c0-3.5 1.9-6.5 4.1-6.5s4.1 3 4.1 6.5v.6H12zm10.6 3.2v9.7s-.1.1-.3.1H9.8c-.1 0-.3-.1-.3-.1v-9.7s.1-.1.3-.1h12.6c.2-.1.2.1.2.1"
  })));
};
export default SvgLock;